import { PRIVATE_BASE_URL } from '../../../../../configs'
import API from '../../../../../services/api'
import { alertSuccess } from 'api'
import { feedbackAPIMessages } from '../../../api/configs'
import { FeedbackAboutQuestionModel, FeedbackPaginateAPIResponse, FeedbackSearchAPI } from '../types'
import { UnknownQuestionModel } from '../../unansweredQuestions/types'

const template = (path = '', params = {}) => {
  const searchParams = new URLSearchParams(params)
  return `${PRIVATE_BASE_URL}/feedback${path}?${searchParams}`
}

const searchUserFeedback = async (params: FeedbackSearchAPI): Promise<FeedbackPaginateAPIResponse> => {
  return API.get(template('', params))
}

const deleteUserFeedback = async (id: string, withAlert = true): Promise<any> => {
  return API.delete(template(`/${id}`)).then(response => {
    if (withAlert) alertSuccess(feedbackAPIMessages.deleted)
    return response
  })
}

const pushQuestionToTheList = (
  id: string,
  body: Partial<{
    subQuestionId: string
    idToPush: string
    toSubQuestion: boolean
  }>,
): Promise<UnknownQuestionModel[]> => {
  return API.put<UnknownQuestionModel[]>(template(`/${id}`), body).then(responseQuestion => {
    return responseQuestion
  })
}

const updateFeedback = async (
  id: string,
  body: Partial<FeedbackAboutQuestionModel>,
  withAlert = true,
): Promise<any> => {
  return API.put(template(`/${id}`), body).then(response => {
    if (withAlert) alertSuccess(feedbackAPIMessages.solved)
    return response
  })
}

const markAsSolved = async (
  id: string,
  withAlert = true,
): Promise<any> => {
  return API.patch(template(`/${id}`)).then(response => {
    if (withAlert) alertSuccess(feedbackAPIMessages.solved)
    return response
  })
}

export const userFeedbackService = {
  searchUserFeedback,
  deleteUserFeedback,
  updateFeedback,
  pushQuestionToTheList,
  markAsSolved
}
